/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import toast from "react-hot-toast";
import { CRUDFormPageProps } from "../../types";
// import { usePagePermissions } from "../../Components/PagePermission";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";
import Layout from "../../Components/Layout";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import AddCourse from "./AddCourse";
import EditCourse from "./EditCourse";

const CRUDForm: React.FC<CRUDFormPageProps> = ({ mode, data, fields }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [editedValues, setEditedValues] = useState<any>({});
  const [selectedModuleImage, setSelectedModuleImage] = useState<any>(null);
  const [moduleImageName, setModuleImageName] = useState<any>(null);
  const [moduleImage, setModuleImage] = useState(null);
  const [formData, setFormData] = useState({
    Module_Name: "",
    Module_Order: 0,

    IsStatus: true,
  });
  const [errors, setErrors] = useState({
    Module_Name: "",
    Module_Order: "",
  });

  const navigate = useNavigate();
  // const permissions = usePagePermissions(9);

  // const theme: Theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    if (mode === "edit" && data) {
      setEditedValues(data);

      setFormData({
        Module_Name: data.Module_Name || "",
        Module_Order: data.Module_Order || 0,
        IsStatus: data.IsStatus || "",
      });
      setSelectedModuleImage(data?.Module_Icon);
    }
  }, [mode, data]);

  const handleInputChange = (key: string, value: any) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleModuleImageChange = (e: any) => {
    const imageFile = e.target.files[0];
    setModuleImageName(imageFile.name);
    setModuleImage(imageFile);
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      Module_Name: "",
      Module_Order: "",
    };

    if (!formData.Module_Name.trim()) {
      newErrors.Module_Name = "Module Name is required";
      isValid = false;
    } else if (formData.Module_Name.length < 3) {
      newErrors.Module_Name = "Module Name must be at least 3 characters long";
      isValid = false;
    }

    if (!formData.Module_Order) {
      newErrors.Module_Order = "Module Order is required";
    } else if (formData.Module_Order < 0) {
      newErrors.Module_Order = "Module Order must be greater than 0";
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    // First submit module data and get the module ID from the response
    let module_id = null;
    try {
      if (mode === "create") {
        const newData = {
          Module_Name: formData.Module_Name,
          Module_Order: formData.Module_Order,
          IsStatus: 1,
        };

        const response = await AxiosInstance.post(
          `${BASE_API_URL}/admin/modules/v1/modules`,
          newData
        );

        if (response.data) {
          module_id = response.data.module_id;
          toast.success("Module created successfully");
          setFormData({
            Module_Name: "",
            Module_Order: 0,
            IsStatus: true,
          });
          // logEvent(9, permissions?.Add?.id, module_id.toString());
        }

        if (module_id && moduleImage) {
          try {
            // Perform API call to upload module image
            const imageFormData = new FormData();
            imageFormData.append("file", moduleImage);

            const imageResponse = await AxiosInstance.post(
              `${BASE_API_URL}/admin/modules/v1/modules/upload-module-icon/${module_id}`,
              imageFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            // Assuming the image upload API returns the file path of the uploaded image
            const imagePath = imageResponse.data.filepath;
          } catch (error) {
            console.error("Error uploading image:", error);
            // Handle error
          }
        }
      } else if (mode === "edit") {
        const newData = {
          Module_Name: formData.Module_Name,
          Module_Order: formData.Module_Order,
          IsStatus: !!formData.IsStatus,
        };

        const response = await AxiosInstance.put(
          `${BASE_API_URL}/admin/modules/v1/modules/${editedValues.Id}`,
          newData
        );

        if (response.data) {
          toast.success("Module updated successfully");
          setFormData({
            Module_Name: "",
            Module_Order: 0,
            IsStatus: true,
          });
          // logEvent(9, permissions?.Update?.id, editedValues.Id.toString());
        }

        if (moduleImage) {
          try {
            // Perform API call to upload module image
            const imageFormData = new FormData();
            imageFormData.append("file", moduleImage);

            const imageResponse = await AxiosInstance.post(
              `${BASE_API_URL}/admin/modules/v1/modules/upload-module-icon/${editedValues.Id}`,
              imageFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            // Assuming the image upload API returns the file path of the uploaded image
            const imagePath = imageResponse.data.filepath;
          } catch (error) {
            console.error("Error uploading image:", error);
            // Handle error
          }
        }
      }
    } catch (error) {
      console.error("Error creating module:", error);
    }
  };

  return (
    <Layout PageId={9}>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            zIndex: 1000,
          }}
        >
          <CircularProgress size={50} />
        </Box>
      )}

      <div className="flex flex-col items-start justify-start w-full h-full mt-4">
        <Grid container spacing={2}>
          {mode === "create" && (
            <>
              <AddCourse />
            </>
          )}
          {mode === "edit" && <EditCourse data={data} />}
          {mode === "view" && (
            <>
              {fields.map(({ label, key, type }) => (
                <Grid item xs={6} key={key}>
                  <TextField
                    key={key}
                    label={label}
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={data[key] || ""}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  />
                </Grid>
              ))}
            </>
          )}
        </Grid>

        <div className="flex flex-row items-center justify-between w-full mt-4">
          {mode === "view" && (
            <Button
              variant="outlined"
              sx={{
                color: "#000",
                border: "1px solid #000",
              }}
              onClick={() => navigate("/courses/manage")}
            >
              Back
            </Button>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CRUDForm;
